export function vhpRemovePanelName(currentName) {
  return currentName.substring(0, 5);
}

export function getPanelName(currentProdsName) {
  return currentProdsName.substring(6);
}

export function getServerIdOnly(serverData) {
  return serverData.map((data) => data.id);
}

export function getPanelIdOnly(panelData) {
  return panelData.map((data) => data.id);
}

export function getFirstVpsProdsName(inputString) {
  if (!inputString) {
    return;
  }

  // Split the input string by the delimiter (hyphen in this case)
  const words = inputString.split("-");

  const vpsName = words[0] === "nano" ? "Nano SC" : words[0].toUpperCase();
  // console.log("🚀 ~ file: helper.js:18 ~ getFirstVpsProdsName ~ vpsName:", vpsName)

  // Return the first word (element) from the resulting array
  return vpsName;
}

export function extractDynamicString(inputString) {
  const regex = /(Nano SC)|(SC\d+)/; // Matches 'SC' followed by one or more digits

  const match = inputString.match(regex);
  if (match) {
    return match[0]; // Returns the matched dynamic string
  }

  return null; // Returns null if no match is found
}

export function buildProdName(prod, bundle, snapshotOpt) {
  let prodname;
  prodname = prod === "Nano" ? "Nano SC" : prod;

  // ! Only for product Nano SC
  if (prodname === "Nano SC" && bundle.includes("DEBIAN 11")) {
    const prodNano = `${prodname} + DEBIAN 11 ${
      snapshotOpt ? "+ GRAV + Snapshot" : ""
    }`;
    return prodNano;
  }

  const finalprodname = snapshotOpt
    ? prodname + bundle + " + Snapshot"
    : prodname + bundle;

  return finalprodname;
}

export async function postFetcher(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  return data;
}

export function checkPasswordStrength(password) {
  // * initial score and sepcial character
  let score = 0;
  const specialChars = "!@#$%^&*()_-+=~`[]{}|;:,.<>?";

  // * check where password contain Upper, Lower & Number
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;

  // * check where password contain sepcial character
  for (let i = 0; i < specialChars.length; i++) {
    if (password.indexOf(specialChars[i]) > -1) {
      score++;
      break;
    }
  }

  // * give additional score if password long enough
  if (password.length >= 8) score++;

  // * return final score, message and variants
  if (score === 0) {
    return { title: "Password terlalu lemah", variant: "danger", score };
  } else if (score === 1) {
    return { title: "Password lemah", variant: "danger", score };
  } else if (score === 2) {
    return { title: "Password cukup kuat", variant: "warning", score };
  } else if (score === 3) {
    return { title: "Password kuat", variant: "success", score };
  } else if (score === 4 || score === 5) {
    return { title: "Password sangat kuat", variant: "success", score };
  }
}

export async function fileToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function sortByName(items) {
  return items.sort((a, b) => a.value - b.value);
}

export async function postOrderAPI(payload, type = "others") {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_API}order-api/api/v1/order/${type}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (data.code !== 200) {
      throw new Error(data.message);
    }

    return data;
  } catch (error) {
    if (error && error.error) {
      const errorKeys = Object.keys(error.error);
      if (errorKeys.length > 0) {
        const firstErrorKey = errorKeys[0];
        const errorMessage = `${firstErrorKey}: ${error.error[
          firstErrorKey
        ].join(", ")}`;
        console.log(errorMessage);
        const err = {
          msg: errorMessage,
          code: 400,
        };
        return err;
      }
    } else {
      console.log(error.message);
      const err = {
        msg: error.message,
        code: 400,
      };
      return err;
    }
  }
}

export function terminReadable(termin) {
  try {
    let terminResult;

    if (!termin) {
      throw new Error("Termin name not available");
    }

    switch (termin) {
      case "triennially":
        terminResult = "3 Tahun";
        break;
      case "biennially":
        terminResult = "2 Tahun";
        break;
      case "annually":
        terminResult = "1 Tahun";
        break;
      case "semiannually":
        terminResult = "6 Bulan";
        break;
      case "quarterly":
        terminResult = "3 Bulan";
        break;
      default:
        terminResult = "1 Bulan";
        break;
    }

    return terminResult;
  } catch (error) {
    console.log(error.message);
  }
}

export function getOnlyTLD(domain = "") {
  try {
    if (!domain || typeof domain !== "string") {
      throw new Error("Domain invalid");
    }

    let fullTld = "";
    let dotCount = 0;
    for (let i = domain.length - 1; i >= 0; i--) {
      if (domain[i] === ".") {
        dotCount++;
        if (dotCount === 1) {
          // ? To get domain 1 dot e.g: .com, .net, .id etc
          fullTld = domain.slice(i);
        } else if (dotCount === 2) {
          // ? To get domain 2 dot e.g: .co.id, .ac.id, etc
          fullTld = domain.slice(i);
        }
      }
    }

    return fullTld;
  } catch (error) {
    return error.message;
  }
}

export function buildProductPayload(item = [], url) {
  try {
    const processItem = item.map((item) => {
      let customfields;
      const vpsAccount = [];
      const hasCFvalue = item.customfieldvalue;

      if (hasCFvalue) {
        customfields = hasCFvalue?.map((cf) => ({
          id: cf.id,
          value: cf.value,
        }));
      }
      if (item.customfield) {
        customfields = item?.customfield.map((cf) => ({
          id: cf.id,
          value: cf.value,
        }));
      }

      if (item.type === "vpn") {
        for (let i = 0; i < item.account; i++) {
          const duplicatedObj = { ...item };
          vpsAccount.push(duplicatedObj);
        }

        return vpsAccount;
      }

      if (item.type === "server") {
        let addons_server = item?.vpsaddons.map((addon) => addon.id) ?? [];
        if (url) {
          addons_server.push(55); // Add addon ID 55
        }
        
        // Filter config options to exclude those with value 0
        const filteredConfigOptions = item.configoptions?.filter((co) => 
          co.value !== null && co.value !== undefined && co.value !== '' && co.value >= 0
        ).map((co) => ({
          id: co.id,
          value: co.value,
        })) ?? [];
        
        return {
          pid: item.pid,
          billingcycle: item.billingcycle,
          hostname: item.hostname,
          rootpw: item.password,
          addons: addons_server,
          customfields:
            item?.customfields.map((cf) => ({
              id: cf.id,
              value: cf.value,
            })) ?? [],
          configoptions: filteredConfigOptions,
        };
      }
      let addons = item?.addon ? [item?.addon.id] : [];
      if (url) {
        addons.push(55); // Add addon ID 55
      }

      // Filter config options to exclude those with value 0
      const filteredConfigOptions = item.configoptions?.filter((co) => 
        co.value !== null && co.value !== undefined && co.value !== '' && co.value >= 0
      ).map((co) => ({
        id: co.id,
        value: co.value,
      })) ?? [];

      return {
        pid: item.pid,
        billingcycle: item?.billingcycle ?? item?.duration ?? "",
        customfields: customfields ?? [],
        configoptions: filteredConfigOptions,
        addons: addons, // HPCH Addons
      };
    });
    return processItem;
  } catch (error) {
    console.warn(error, "buildProductKeyPayload");
  }
}

export function extractDomainName(domain, extensions = null) {
  const TLDs = extensions
    ? extensions.join()
    : [
        "ac",
        "ad",
        "ae",
        "aero",
        "af",
        "ag",
        "ai",
        "al",
        "am",
        "an",
        "ao",
        "aq",
        "ar",
        "arpa",
        "as",
        "asia",
        "at",
        "au",
        "aw",
        "ax",
        "az",
        "ba",
        "bb",
        "bd",
        "be",
        "bf",
        "bg",
        "bh",
        "bi",
        "biz",
        "bj",
        "bm",
        "bn",
        "bo",
        "br",
        "bs",
        "bt",
        "bv",
        "bw",
        "by",
        "bz",
        "ca",
        "cat",
        "cc",
        "cd",
        "cf",
        "cg",
        "ch",
        "ci",
        "ck",
        "cl",
        "cm",
        "cn",
        "co",
        "com",
        "coop",
        "cr",
        "cu",
        "cv",
        "cx",
        "cy",
        "cz",
        "de",
        "dj",
        "dk",
        "dm",
        "do",
        "dz",
        "ec",
        "edu",
        "ee",
        "eg",
        "er",
        "es",
        "et",
        "eu",
        "fi",
        "fj",
        "fk",
        "fm",
        "fo",
        "fr",
        "ga",
        "gb",
        "gd",
        "ge",
        "gf",
        "gg",
        "gh",
        "gi",
        "gl",
        "gm",
        "gn",
        "gov",
        "gp",
        "gq",
        "gr",
        "gs",
        "gt",
        "gu",
        "gw",
        "gy",
        "hk",
        "hm",
        "hn",
        "hr",
        "ht",
        "hu",
        "id",
        "ie",
        "il",
        "im",
        "in",
        "info",
        "int",
        "io",
        "iq",
        "ir",
        "is",
        "it",
        "je",
        "jm",
        "jo",
        "jobs",
        "jp",
        "ke",
        "kg",
        "kh",
        "ki",
        "km",
        "kn",
        "kp",
        "kr",
        "kw",
        "ky",
        "kz",
        "la",
        "lb",
        "lc",
        "li",
        "lk",
        "lr",
        "ls",
        "lt",
        "lu",
        "lv",
        "ly",
        "ma",
        "mc",
        "md",
        "me",
        "mg",
        "mh",
        "mil",
        "mk",
        "ml",
        "mm",
        "mn",
        "mo",
        "mobi",
        "mp",
        "mq",
        "mr",
        "ms",
        "mt",
        "mu",
        "museum",
        "mv",
        "mw",
        "mx",
        "my",
        "mz",
        "na",
        "name",
        "nc",
        "ne",
        "net",
        "nf",
        "ng",
        "ni",
        "nl",
        "no",
        "np",
        "nr",
        "nu",
        "nz",
        "om",
        "org",
        "pa",
        "pe",
        "pf",
        "pg",
        "ph",
        "pk",
        "pl",
        "pm",
        "pn",
        "pr",
        "pro",
        "ps",
        "pt",
        "pw",
        "py",
        "qa",
        "re",
        "ro",
        "rs",
        "ru",
        "rw",
        "sa",
        "sb",
        "sc",
        "sd",
        "se",
        "sg",
        "sh",
        "si",
        "sj",
        "sk",
        "sl",
        "sm",
        "sn",
        "so",
        "sr",
        "st",
        "su",
        "sv",
        "sy",
        "sz",
        "tc",
        "td",
        "tel",
        "tf",
        "tg",
        "th",
        "tj",
        "tk",
        "tl",
        "tm",
        "tn",
        "to",
        "tp",
        "tr",
        "travel",
        "tt",
        "tv",
        "tw",
        "tz",
        "ua",
        "ug",
        "uk",
        "us",
        "uy",
        "uz",
        "va",
        "vc",
        "ve",
        "vg",
        "vi",
        "vn",
        "vu",
        "wf",
        "ws",
        "xn--0zwm56d",
        "xn--11b5bs3a9aj6g",
        "xn--3e0b707e",
        "xn--45brj9c",
        "xn--80akhbyknj4f",
        "xn--90a3ac",
        "xn--9t4b11yi5a",
        "xn--clchc0ea0b2g2a9gcd",
        "xn--deba0ad",
        "xn--fiqs8s",
        "xn--fiqz9s",
        "xn--fpcrj9c3d",
        "xn--fzc2c9e2c",
        "xn--g6w251d",
        "xn--gecrj9c",
        "xn--h2brj9c",
        "xn--hgbk6aj7f53bba",
        "xn--hlcj6aya9esc7a",
        "xn--j6w193g",
        "xn--jxalpdlp",
        "xn--kgbechtv",
        "xn--kprw13d",
        "xn--kpry57d",
        "xn--lgbbat1ad8j",
        "xn--mgbaam7a8h",
        "xn--mgbayh7gpa",
        "xn--mgbbh1a71e",
        "xn--mgbc0a9azcg",
        "xn--mgberp4a5d4ar",
        "xn--o3cw4h",
        "xn--ogbpf8fl",
        "xn--p1ai",
        "xn--pgbs0dh",
        "xn--s9brj9c",
        "xn--wgbh1c",
        "xn--wgbl6a",
        "xn--xkc2al3hye2a",
        "xn--xkc2dl3a5ee0h",
        "xn--yfro4i67o",
        "xn--ygbi2ammx",
        "xn--zckzah",
        "xxx",
        "ye",
        "yt",
        "za",
        "zm",
        "zw",
      ].join();

  let parts = domain.split("."),
    ln = parts.length,
    i = ln,
    minLength = parts[parts.length - 1].length,
    part;

  while ((part = parts[--i])) {
    if (
      TLDs.indexOf(part) < 0 ||
      part.length < minLength ||
      i < ln - 2 ||
      i === 0
    ) {
      return part;
    }
  }
}

export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export async function postUpgradeAPI(payload) {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_API + 'order/apis/processUpgrade.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling upgrade API:', error);
    throw new Error('Failed to process upgrade order');
  }
}

export async function postRenewAPI(payload) {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_API + 'order/apis/processRenew.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling renew API:', error);
    throw new Error('Failed to process renewal order');
  }
}

export async function postAddonAPI(payload) {
  try {
    const response = await fetch(
      process.env.REACT_APP_BASE_API + 'order/apis/processAddon.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error calling addon API:', error);
    throw new Error('Failed to process addon order');
  }
}
